@if (this.isShow) {
  <ng-content></ng-content>
}